export default {
  en: {
    ACCOUNT_BILLING_PAUSED: 'Your numbers have been paused due to nonpayment. Go to {link} to add a new credit card to your account.',
    ACCOUNT_BILLING_PAUSED_LINK: 'Settings > Billing Settings',
    UPLOAD_KYC_NOTIFICATION_MESSAGE: 'Please {link} your credit card to avoid service disruption.',
    UPLOAD_KYC_NOTIFICATION_MESSAGE_LINK: 'verify',
    
  }
};